import { MenuCategoryCreatePage } from "@/features/menu-category/pages/MenuCategoryCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/menu-category/create")({
	component: MenuCategoryCreatePage,
});
